export default __webpack_public_path__ + "static/media/map-green.3355d9ec.svg";